export type ChannelInfo = {
  title: string
  id: number
  license_time: string
  license_type: number
  avatar: string
  state: string
  members_count: number
  username: string
  config_version: number
  linked_chat_id: any
  linked_chat_username: any
  test_state: string
  limited_subscription_type: ChannelLimitedTypeEnum
}

export enum ChannelLimitedTypeEnum {
  None = 'None',
  Channel = 'Channel',
  Comments = 'Comments',
  Content = 'Content',
  Sponsorship = 'Sponsorship',
}
